import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function analysisEquipmentList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/equipment/list${queryString}`,
  );
}

export async function analysisEquipmentCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    analysis_id: string;
    equipment_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/equipment/create`,
    payload,
  );
}

export async function analysisEquipmentDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/analysis/equipment/${item_id}/delete`,
  );
}
